import { useEffect, useRef, useState } from "react";
import Editor, { OnMount } from "@monaco-editor/react";
import api from "../components/customAxios/Axios";
import { useNavigate } from "react-router-dom";
import { useLoader } from "@/context/loaderContext";
import New_Sidebar from "../components/AssessmentSideBar";
import SelectCodingLanguage from "../components/CodingTest/SelectCodingLanguage";
import * as monaco from "monaco-editor";
import CodeOutput from "../components/CodingTest/CodeOutput";
import { templateCode } from "../components/CodingTest/CodingLanguageVersion";
import { useTimerContext } from "@/context/TimerContext";
import AssessmentLableAndTimer from "@/components/AssessmentLableAndTimer";
import CodeDetailsQuestions from "@/components/CodingTest/CodeDetailsQuestions";
import AssessmentProgressBar from "@/components/AssessmentProgressBar";
import AssessmentPagesFooter from "@/components/AssessmentPagesFooter";

interface CodingQuestion {
	coding_ques_id: number;
	question: string;
	sample_input: string;
	sample_output: string;
}
type codingLanguageValue = "javascript" | "java" | "python" | "csharp" | "ruby" | "php";
const CodingTest = () => {
	const { setLoading } = useLoader();
	const navigate = useNavigate();

	const { timeLeft, setTimeLeft, isTimeUp, setIsTimeUp, setIsPaused } =
		useTimerContext();
	const [codingLanguage, setCodingLanguage] =
		useState<codingLanguageValue>("javascript");
	const [code, setCode] = useState<string>("");
	const codeEditor = useRef<monaco.editor.IStandaloneCodeEditor | null>(null);

	const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
	const [codingQuestions, setCodingQuestions] = useState<CodingQuestion[]>([]);
	const [currentQuestion, setCurrentQuestion] = useState<CodingQuestion>();
	const [runCode, setRunCode] = useState(false);
	const [showFollowUpQuestion, setShowFollowupQuestion] = useState(false);
	const assessmentData = JSON.parse(sessionStorage.getItem("question") || "{}");
	useEffect(() => {
		if (sessionStorage.getItem("followUpQuestion")) {
			setShowFollowupQuestion(true);
			setIsPaused(true);
		}
		setIsTimeUp(false);
		setTimeLeft(900);
		const questions = assessmentData.coding_question;
		if (questions) {
			setCurrentQuestion(questions[0]);
			setCodingQuestions(questions);
			if (assessmentData.coding_language[0]) {
				setCodingLanguage(assessmentData.coding_language[0].toLowerCase());
			}
		} else {
			navigate("/feedback-form");
		}
	}, []);

	useEffect(() => {
		console.log(currentQuestionIndex, assessmentData.coding_question.length);
		if (currentQuestionIndex < assessmentData.coding_question.length) {
			setTimeLeft(900);
			setCode(templateCode[codingLanguage]);
			setIsTimeUp(false);
			setCurrentQuestion(codingQuestions[currentQuestionIndex]);
		} else {
			delete assessmentData.coding_question;
			delete assessmentData.coding_language;
			sessionStorage.setItem("question", JSON.stringify(assessmentData));
			navigate("/feedback-form");
		}
	}, [currentQuestionIndex]);
	useEffect(() => {
		setCode(templateCode[codingLanguage]);
	}, [codingLanguage, currentQuestionIndex]);
	console.log(currentQuestion);
	const saveCurrentCode = async () => {
		const currentQuestion = codingQuestions[currentQuestionIndex];
		if (!currentQuestion) return false;

		if (!code?.trim()) {
			alert("Please enter some code before submitting.");
			return false;
		}

		// const currentResponseIndex = codeResponses.findIndex(
		// 	(response) => response.question_id === currentQuestion.coding_ques_id
		// );

		// const newCodeResponse = {
		// 	question_id: currentQuestion.coding_ques_id,
		// 	user_code: code,
		// };

		// if (currentResponseIndex > -1) {
		// 	// Update existing response
		// 	setCodeResponses((prevResponses) => {
		// 		const updatedResponses = [...prevResponses];
		// 		updatedResponses[currentResponseIndex] = newCodeResponse;
		// 		return updatedResponses;
		// 	});
		// } else {
		// 	// Add new response
		// 	setCodeResponses((prevResponses) => [...prevResponses, newCodeResponse]);
		// }

		// Submit the current code response
		try {
			setLoading(true);
			const candidateId = assessmentData.candidate_id;

			const resp = await api.post("/store_code_response", {
				candidate_id: candidateId,
				question_id: currentQuestion.coding_ques_id,
				user_code: code,
			});

			if (resp.status === 200) {
				sessionStorage.setItem(
					"followUpQuestion",
					JSON.stringify(resp.data.followup_questions)
				);
				setShowFollowupQuestion(true);
				setIsPaused(true);
			}
		} catch (error: any) {
			// add toast
		} finally {
			setLoading(false);
		}
	};

	// const handleNext = async () => {
	// 	if (currentQuestionIndex < codingQuestions.length - 1) {
	// 		if (!code?.trim()) {
	// 			alert("Please enter some code before moving to the next question.");
	// 			return;
	// 		}
	// 		const success = await saveCurrentCode();
	// 		if (success) {
	// 			setTimeLeft(900);
	// 			setCode(templateCode[codingLanguage]); // Clear the code editor for the next question
	// 			setCurrentQuestionIndex(currentQuestionIndex + 1);
	// 			setIsTimeUp(false);
	// 		}
	// 	}
	// };

	// const codeSubmit = async () => {
	// 	if (!code?.trim()) {
	// 		alert("Please enter some code before submitting.");
	// 		return;
	// 	}
	// 	const success = await saveCurrentCode();
	// 	if (success) {
	// 		delete assessmentData.coding_question;
	// 		delete assessmentData.coding_language;
	// 		sessionStorage.setItem("question", JSON.stringify(assessmentData));
	// 		navigate("/feedback-form");
	// 		// alert("submiitted");
	// 	}
	// };

	// useEffect(() => {
	// 	const currentResponse = codeResponses.find(
	// 		(response) =>
	// 			response.question_id ===
	// 			codingQuestions[currentQuestionIndex]?.coding_ques_id
	// 	);
	// 	setCode(currentResponse ? currentResponse.user_code : "");
	// }, [currentQuestionIndex]);

	useEffect(() => {
		if (isTimeUp) {
			saveCurrentCode();
		}
	}, [isTimeUp]);

	const onMountEditor: OnMount = (editor) => {
		setCode(templateCode[codingLanguage]);
		codeEditor.current = editor;
		editor.focus(); // Automatically focus the editor on mount
	};

	if (codingQuestions.length === 0) {
		navigate("/feedback-form");
		return null;
	}

	return (
		<div className="">
			<New_Sidebar />
			{codingQuestions.length > 0 && (
				<>
					<AssessmentProgressBar
						current={currentQuestionIndex}
						total={codingQuestions.length}
					/>
					<div className=" mx-5 border-1 rounded-xl">
						<AssessmentLableAndTimer
							timeLeft={timeLeft}
							label="Coding Assessment"
						// label={`Coding Assessment - ${currentQuestionIndex + 1}/${
						// 	codingQuestions.length
						// }`}
						/>

						<div className="bg-white rounded-lg shadow-md">
							<div className="px-6 py-4">
								<p className=" text-lg mb-2">
									{currentQuestionIndex + 1 + ". "}{" "}
									{codingQuestions[currentQuestionIndex]?.question}
								</p>
								<div className="font-body space-y-3 mt-3">
									<div>
										<h2 className="font-medium  text-gray-700 mb-1">
											Sample Input
										</h2>
										<p className=" mb-4 font-mono  text-gray-900 p-3 rounded-lg border-1">
											{codingQuestions[currentQuestionIndex]?.sample_input}
										</p>
									</div>
									<div>
										<h2 className="font-medium text-gray-700 mb-1">
											Sample Output
										</h2>
										<p className="font-mono  text-gray-900 p-3 rounded-lg border-1">
											{codingQuestions[currentQuestionIndex]?.sample_output}
										</p>
									</div>
								</div>
							</div>

							<div className="px-6 pb-4">
								<div className="flex justify-between">
									<div className="w-[200px] mb-4">
										<SelectCodingLanguage
											codingLanguage={codingLanguage}
											setCodingLanguage={setCodingLanguage}
										/>
									</div>
									<div className="flex mt-6 items-center gap-3">
										<div>
											<button
												onClick={() => setRunCode((prev) => !prev)}
												className="py-2 px-3 rounded-md  font-semibold bg-[#EBEBEB] hover:scale-110  transition  "
											>
												Run Code
											</button>
											{/* <button
												className="px-6 py-2 border-1 border-[#BDE4C3] text-[#BDE4C3]   font-medium rounded-lg   hover:scale-110 transition-all"
												onClick={() => setRunCode((prev) => !prev)}
											>
												Run Code
											</button> */}
										</div>
										{/* <button
											onClick={saveCurrentCode}
											className="bg-[#BDE4C3] text-[#438437] font-medium rounded-lg px-6 py-2.5 hover:scale-110 transition-all"
										>
											Submit & Next
										</button> */}
										<button
											type="submit"
											onClick={saveCurrentCode}
											className="py-2 px-3  rounded-md bg-black text-white hover:scale-110  transition"
										>
											Submit
										</button>
										{/* <div className=" ">
									{currentQuestionIndex < codingQuestions.length - 1 ? (
										<button
											onClick={handleNext}
											className="px-3 py-2 bg-[#0B67BC] text-white font-medium rounded-lg shadow hover:bg-[#0b66bccf] transition focus:ring-2 focus:ring-blue-400"
										>
											Submit & Next
										</button>
									) : (
										<button
											onClick={codeSubmit}
											className="px-3 py-2 bg-[#0B67BC] text-white font-medium rounded-lg shadow hover:bg-[#0b66bccf] 
											 transition focus:ring-2 focus:ring-green-400"
										>
											Submit Final
										</button>
									)}
								</div> */}

										<CodeDetailsQuestions
											showFollowUpQuestion={showFollowUpQuestion}
											setShowFollowupQuestion={setShowFollowupQuestion}
											setCurrentQuestionIndex={setCurrentQuestionIndex}
										/>
									</div>
								</div>

								<div className="flex  gap-2 justify-between items-start h-[60vh]">
									<div className="w-[60%] h-full rounded-lg shadow-lg border border-gray-300 overflow-hidden">
										<Editor
											className="p-4 bg-gray-50"
											height="100%"
											language={codingLanguage}
											value={code}
											onChange={(value: string | undefined) =>
												setCode(value || "")
											}
											onMount={onMountEditor}
											options={{
												contextmenu: false,
												minimap: { enabled: false },
											}}
										/>
									</div>

									<CodeOutput
										setRunCode={setRunCode}
										editorRef={codeEditor}
										language={codingLanguage}
										runCode={runCode}
									></CodeOutput>
								</div>
							</div>
						</div>
					</div>
					<AssessmentPagesFooter />
				</>
			)}
		</div>
	);
};

export default CodingTest;
